import React, { useState, useEffect } from "react";
import {
  DialogActions,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Checkbox,
  FormControlLabel,
  FormControl,
  FormLabel,
  Collapse,
  Chip,
  RadioGroup,
  Radio,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  MenuItem,
  InputLabel,
  Select,
} from "@material-ui/core";

import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { useTranslation } from "react-i18next";
import moment from "moment";
import MomentUtils from "@date-io/moment";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { withTranslation } from "react-i18next";
import { DatePicker } from "@material-ui/pickers";
import { makeStyles } from "@material-ui/core/styles";
import UserTeamPicker from "../../required-reading/UserTeamPicker";
import DocumentAutosuggest from "../../document/DocumentAutosuggest";
import axios from "../../../AxiosClient";
import { taxServiceClient } from "../../../AxiosClient";
import CardList from "../../../core-elements/CardList";
import ItemRequiredReadingDocument from "../../list-item/ItemRequiredReadingDocument";
import FilterWrapper from "../../filter/FilterWrapper";
import { DragDropContext } from "react-beautiful-dnd";

const useStyles = makeStyles((theme) => ({
  filterDiv: {
    marginTop: 15,
  },
  formControl: {
    display: "flex",
    flex: "1 1 100%",
    margin: theme.spacing(1),
  },
  sliderControl: {
    display: "flex",
    flex: "1 1 50%",
    margin: theme.spacing(6),
    marginBottom: theme.spacing(2),
  },
}));

function QueryParametersDialog(props) {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [dateRangeUnits, setDateRangeUnits] = useState("day");
  const [dateRangeQualifier, setDateRangeQualifier] = useState("current");
  const [savedDateRangeUnits, setSavedDateRangeUnits] = useState("day");
  const [savedDateRangeQualifier, setSavedDateRangeQualifier] = useState(
    "current"
  );
  const { t } = useTranslation();
  const classes = useStyles();
  const [expanded, setExpanded] = useState("range");
  const [allUsers, setAllUsers] = useState(true);
  const [allDocuments, setAllDocuments] = useState(true);
  const [users, setUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [usedKeys, setUsedKeys] = useState([]);
  const [keys, setKeys] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [statsFor, setStatsFor] = useState("users");
  const [query, setQuery] = useState({});
  const [showColumns, setShowColumns] = useState(false);
  const [groupByKey, setGroupByKey] = useState();
  const [includeSummary, setIncludeSummary] = useState(false);
  const [includeSummaryChart, setIncludeSummaryChart] = useState(false);
  const [numericColumns, setNumericColumns] = useState([]);
  const [filters, setFilters] = useState({
    sort: "createdDate",
    sortDirection: "DESC",
    draft: "Live",
    titleContains: "",
    favourited: false,
    liked: false,
    viewed: false,
    modifiedSinceLastSeen: false,
    onlyCreatedRecently: false,
    modifiedInLast: 0,
    taxonomyDialogOpen: false,
    createdBy: [],
    modifiedBy: [],
    taxonomy: [],
    createdStart: "",
    createdEnd: "",
    modifiedStart: "",
    modifiedEnd: "",
    loadingUsers: false,
  });

  useEffect(
    () => {
      if (props.params) {
        if (props.params.hasOwnProperty("chart")) {
          if (props.params.chart.hasOwnProperty("query")) {
            try {
              let query = JSON.parse(props.params.chart.query).variables;
              setQuery(query);
            } catch (x) {}
          }
          if (props.params.chart.hasOwnProperty("usedKeys")) {
            setUsedKeys(props.params.chart.usedKeys);
          }
          if (props.params.chart.hasOwnProperty("keys")) {
            setKeys(props.params.chart.keys);
          }
          if (props.params.chart.hasOwnProperty("groupByKey")) {
            setGroupByKey(props.params.chart.groupByKey);
          }
          if (props.params.chart.hasOwnProperty("includeSummary")) {
            setIncludeSummary(props.params.chart.includeSummary);
          }
          if (props.params.chart.hasOwnProperty("includeSummaryChart")) {
            setIncludeSummaryChart(props.params.chart.includeSummaryChart);
          }
          if (props.params.chart.hasOwnProperty("numericColumns")) {
            setNumericColumns(props.params.chart.numericColumns);
          }
        }
      }
    },
    [props.params]
  );
  useEffect(
    () => {
      if (query.hasOwnProperty("dateRange")) {
        setDateRangeUnits(query.dateRange.units);
        setSavedDateRangeUnits(query.dateRange.units);
        setDateRangeQualifier(query.dateRange.qualifier);
        setSavedDateRangeQualifier(query.dateRange.qualifier);
        query.dateRange.startDate && setStartDate(query.dateRange.startDate);
        query.dateRange.endDate && setEndDate(query.dateRange.endDate);

        if (
          query.dateRange.startDate !== null ||
          query.dateRange.endDate !== null
        ) {
          setExpanded("specific");
        }
      }
      setStatsFor(
        query.hasOwnProperty("userList")
          ? "users"
          : query.hasOwnProperty("documentList")
            ? "documents"
            : "topics"
      );
      if (query.hasOwnProperty("userList")) {
        setAllUsers(query.userList.length === 0);
        if (query.userList.length > 0) {
          taxServiceClient
            .post("/user/userlist", { userIds: query.userList })
            .then((res) => {
              setUsers(res.data);
              setSelectedUsers(res.data);
            });
        }
      }
      if (query.hasOwnProperty("documentList")) {
        setAllDocuments(query.documentList.length === 0);
        setDocuments(
          query.documentList.map((id) => {
            return {
              documentID: id,
            };
          })
        );
      }
    },
    [query]
  );
  useEffect(
    () => {
      if (
        usedKeys.length > 0 &&
        !usedKeys.some((key) => numericColumns.includes(key))
      ) {
        setIncludeSummary(false);
        setIncludeSummaryChart(false);
      }
    },
    [usedKeys]
  );
  const handleRadioChange = (event) => {
    if (event.target.value === "all") {
      setAllUsers(true);
    } else {
      setAllUsers(false);
    }
  };
  const handleDocumentRadioChange = (event) => {
    if (event.target.value === "all") {
      setAllDocuments(true);
    } else {
      setAllDocuments(false);
    }
  };
  const onUsersUpdate = (newUsers) => {
    setUsers([...newUsers]);
  };

  const onTeamUsersUpdate = (newUsers) => {
    setUsers([
      ...users,
      ...newUsers.map((id) => {
        return { userId: id };
      }),
    ]);
  };

  const onDocumentSelected = (doc) => {
    if (documents.filter((d) => d.documentID === doc.documentID).length === 0) {
      setDocuments([...documents, doc]);
    } else {
      setDocuments(documents.filter((d) => d.documentID !== doc.documentID));
    }
  };
  const removeDocument = (doc) => {
    setDocuments(documents.filter((ele) => ele.documentId !== doc.documentId));
  };

  const onFilterChange = (filter) => {
    if (filter.hasOwnProperty("taxonomy") === true) {
      if (
        filter.taxonomy.filter(
          (ele) => ele.type === "taxonomy" && ele.parentList.length === 0
        ).length > 0
      ) {
        filter.taxonomy = [];
      }
    }
    setFilters(filter);
  };
  const changedUsedKey = (key, checked) => {
    let usedKeyList = usedKeys.slice(0);
    let index = null;
    if (checked) {
      usedKeyList.push(key);
    } else {
      index = usedKeyList.indexOf(key);
      usedKeyList.splice(index, 1);
    }
    setUsedKeys(usedKeyList);
  };
  const dateOptions = (
    <>
      <Accordion expanded={expanded === "range"}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          id="date-range-accordion"
          onClick={(event) =>
            expanded !== "range" ? setExpanded("range") : setExpanded("none")
          }
        >
          <FormControlLabel
            aria-label={t("global_date_range")}
            onClick={(event) => event.stopPropagation()}
            onFocus={(event) => event.stopPropagation()}
            control={
              <Checkbox checked={startDate === null && endDate === null} />
            }
            label={t("global_date_range")}
          />
        </AccordionSummary>
        <AccordionDetails>
          <FormControl className={classes.formControl}>
            <RadioGroup
              row
              aria-label="Date range current or previous"
              id="date-range-qualifier"
              value={dateRangeQualifier}
              onChange={(e) => {
                setStartDate(null);
                setEndDate(null);
                setDateRangeQualifier(e.target.value);
              }}
            >
              <FormControlLabel
                value="current"
                control={<Radio />}
                label={t("global_current")}
              />
              <FormControlLabel
                value="previous"
                control={<Radio />}
                label={t("global_previous")}
              />
            </RadioGroup>
            <RadioGroup
              row
              aria-label="Date range selector"
              id="date-range-units"
              value={dateRangeUnits}
              onChange={(e) => {
                setStartDate(null);
                setEndDate(null);
                setDateRangeUnits(e.target.value);
              }}
            >
              <FormControlLabel
                value="day"
                control={<Radio />}
                label={t("global_day")}
              />
              <FormControlLabel
                value="week"
                control={<Radio />}
                label={t("global_week")}
              />
              <FormControlLabel
                value="month"
                control={<Radio />}
                label={t("global_month")}
              />
              <FormControlLabel
                value="year"
                control={<Radio />}
                label={t("global_year")}
              />
            </RadioGroup>
          </FormControl>
        </AccordionDetails>
      </Accordion>
      <Accordion expanded={expanded === "specific"}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          onClick={(event) =>
            expanded !== "specific"
              ? setExpanded("specific")
              : setExpanded("none")
          }
        >
          <FormControlLabel
            aria-label={t("report_specific_dates")}
            onClick={(event) => event.stopPropagation()}
            onFocus={(event) => event.stopPropagation()}
            control={
              <Checkbox checked={startDate !== null || endDate !== null} />
            }
            label={t("report_specific_dates")}
          />
        </AccordionSummary>
        <AccordionDetails>
          <MuiPickersUtilsProvider utils={MomentUtils}>
            <FormControl className={classes.formControl}>
              <DatePicker
                autoOk
                label={t("report_start_date")}
                clearable
                disableFuture
                maxDate={endDate !== null ? moment(endDate) : new Date()}
                value={startDate ? moment(startDate) : null}
                onChange={(e) => {
                  setDateRangeQualifier(
                    e === null && endDate === null
                      ? savedDateRangeQualifier
                      : null
                  );
                  setDateRangeUnits(
                    e === null && endDate === null ? savedDateRangeUnits : null
                  );
                  setStartDate(
                    e !== null
                      ? new Date(e.startOf("day").valueOf()).getTime()
                      : null
                  );
                }}
              />
            </FormControl>
            <FormControl className={classes.formControl}>
              <DatePicker
                autoOk
                label={t("report_end_date")}
                clearable
                disableFuture
                minDate={
                  startDate !== null
                    ? moment(startDate)
                    : new Date("1900-01-01")
                }
                value={endDate ? moment(endDate) : null}
                onChange={(e) => {
                  setDateRangeQualifier(
                    e === null && startDate === null
                      ? savedDateRangeQualifier
                      : null
                  );
                  setDateRangeUnits(
                    e === null && startDate === null
                      ? savedDateRangeUnits
                      : null
                  );
                  setEndDate(
                    e !== null
                      ? new Date(e.endOf("day").valueOf()).getTime()
                      : null
                  );
                }}
              />
            </FormControl>
          </MuiPickersUtilsProvider>
        </AccordionDetails>
      </Accordion>
    </>
  );
  const columnSelections = (
    <>
      <Accordion expanded={showColumns}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="columns-included-accordion"
          onClick={(event) => setShowColumns(!showColumns)}
        >
          <FormLabel component="legend">{t("report_select_columns")}</FormLabel>
        </AccordionSummary>
        <AccordionDetails>
          <FormControl className={classes.formControl} id="column-list">
            {keys.map((key) => (
              <FormControlLabel
                control={
                  <Checkbox
                    checked={usedKeys.includes(key)}
                    onChange={(e) => changedUsedKey(key, e.target.checked)}
                  />
                }
                label={t("report_column_" + key).toUpperCase()}
              />
            ))}
          </FormControl>
        </AccordionDetails>
      </Accordion>
    </>
  );
  let summaryOptions = (
    <>
      <FormControl className={classes.formControl}>
        <InputLabel id="report_groupby_label">
          {t("report_group_by")}
        </InputLabel>
        <Select
          MenuProps={{
            style: { zIndex: 10002 },
          }}
          value={groupByKey ? groupByKey : keys[0]}
          onChange={(e) => {
            setGroupByKey(e.target.value);
          }}
          inputProps={{
            name: "groupByKey",
            id: "groupByKey",
          }}
        >
          <MenuItem key={"none"} value={"none"}>
            {t("report_column_none").toUpperCase()}
          </MenuItem>
          {keys.map((key, index) => (
            <MenuItem key={key + "-" + index} value={key}>
              {t("report_column_" + key).toUpperCase()}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {groupByKey !== "none" &&
        numericColumns.length > 0 &&
        usedKeys.some((key) => numericColumns.includes(key)) && (
          //only show the summary if we have a field to group by
          <FormControl>
            <FormControlLabel
              control={
                <Checkbox
                  checked={includeSummary}
                  onChange={(e) => setIncludeSummary(e.target.checked)}
                />
              }
              label={t("report_include_summary_table")}
            />
          </FormControl>
        )}
      {numericColumns.length > 0 &&
        usedKeys.some((key) => numericColumns.includes(key)) && (
          <FormControl>
            <FormControlLabel
              control={
                <Checkbox
                  checked={includeSummaryChart}
                  onChange={(e) => setIncludeSummaryChart(e.target.checked)}
                />
              }
              label={t("report_include_summary_chart")}
            />
          </FormControl>
        )}
    </>
  );
  return (
    <Dialog
      open={props.open}
      onClose={props.onClose}
      PaperProps={{ style: { overflow: "inherit" } }}
    >
      <DialogTitle>{t("report_query_params")}</DialogTitle>
      <DialogContent>
        {summaryOptions}
        {dateOptions}
        <Collapse in={statsFor === "users"}>
          <div className={classes.filterDiv}>
            <FormControl className={classes.formControl}>
              <FormLabel component="legend">
                {t("report_show_stats_for")}
              </FormLabel>
              <RadioGroup
                row
                aria-label="users-or-teams"
                name="users-or-teams"
                value={allUsers ? "all" : "specific"}
                onChange={handleRadioChange}
              >
                <FormControlLabel
                  value="all"
                  control={<Radio />}
                  label={t("report_all_users")}
                />
                <FormControlLabel
                  value="specific"
                  control={<Radio />}
                  label={t("report_specific_users_or_team")}
                />
              </RadioGroup>
            </FormControl>
            <Collapse in={!allUsers}>
              <Typography>{t("report_selected_users")}</Typography>
              <UserTeamPicker
                onTeamUsersUpdate={onTeamUsersUpdate}
                onUsersUpdate={onUsersUpdate}
                userHeaderKey="create_message_users_header"
                userTeamHeaderKey="create_message_users_team_header"
                asChips
                loadUsers={selectedUsers}
              />
            </Collapse>
          </div>
        </Collapse>
        <Collapse in={statsFor === "documents"}>
          <div>
            <FormControl className={classes.formControl}>
              <FormLabel component="legend">
                {t("report_show_stats_for")}
              </FormLabel>
              <RadioGroup
                row
                aria-label="All or specific documents"
                id="all-or-specific-documents"
                value={allDocuments ? "all" : "specific"}
                onChange={handleDocumentRadioChange}
              >
                <FormControlLabel
                  value="all"
                  control={<Radio />}
                  label={t("report_all_documents")}
                />
                <FormControlLabel
                  value="specific"
                  control={<Radio />}
                  label={t("report_specific_documents")}
                />
              </RadioGroup>
            </FormControl>
            <Collapse in={!allDocuments}>
              <Typography style={{ marginBottom: 10 }}>
                {t("report_show_stats_for_documents")}
              </Typography>
              <div className={classes.infoContainer}>
                <FilterWrapper
                  asPopper={false}
                  open={true}
                  filterElement={"FilterDocuments"}
                  filter={filters}
                  onFilterChange={onFilterChange}
                  isFilterBar={false}
                  disabledFilters={["draft"]}
                />
                <div
                  style={{ height: 300, marginBottom: 10 }}
                  id="report-document-list"
                >
                  {!allDocuments && (
                    <DragDropContext onDragEnd={() => {}}>
                      <CardList
                        parameters={filters}
                        listItem={ItemRequiredReadingDocument}
                        isPortlet={false}
                        selectedDocuments={documents}
                        listOnly
                        onItemClick={onDocumentSelected}
                        portlet={{ id: Math.floor(Math.random() * 1000) + 1 }}
                        listItemTitleColumn={{
                          name: "title",
                          message: "global_document_title",
                        }}
                        messageType="com.kpsol.api.apicommon.document.DocumentInterface"
                      />
                    </DragDropContext>
                  )}
                </div>
              </div>
            </Collapse>
          </div>
        </Collapse>
        {columnSelections}
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onClose} color="default">
          {t("global_cancel")}
        </Button>
        <Button
          // disabled={!documentLinkTitle}
          onClick={() => {
            let params = {};
            let dateRange = {};
            let variables = {};
            dateRange.units = dateRangeUnits;
            dateRange.qualifier = dateRangeQualifier;
            dateRange.startDate = startDate;
            dateRange.endDate = endDate;
            variables.dateRange = dateRange;
            statsFor === "users" &&
              (variables.userList =
                users.length > 0 && !allUsers
                  ? users.map((u) => u.userId)
                  : []);
            statsFor === "documents" &&
              (variables.documentList =
                documents.length > 0 && !allDocuments
                  ? documents.map((d) => d.documentID)
                  : []);
            const sortProp = query.hasOwnProperty("userSort")
              ? "userSort"
              : query.hasOwnProperty("documentSort")
                ? "documentSort"
                : "topicSort";
            //sort will not have changed
            variables[sortProp] = query[sortProp];
            params.variables = variables;
            params.usedKeys = usedKeys;
            params.groupByKey = groupByKey;
            params.includeSummary = includeSummary;
            params.includeSummaryChart = includeSummaryChart;
            props.setQueryParams(params);
          }}
          id="query-params-ok"
          color="default"
        >
          {t("global_ok")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
export default withTranslation()(QueryParametersDialog);
